<template>
  <div class="view view-login">
    <div class="container">
      <ul>
        <li>
          <button class="button" @click="signInWithFb">Log in with Facebook</button>
        </li>
        <li>
          <button class="button" @click="signInWithGoogle">Log in with Google</button>
        </li>
        <li>
          <!--<button class="button" @click="signOut">Log out</button>-->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

  import firebase from 'firebase'
  import axios from 'axios'
  import {mapState} from 'vuex'
  const provider = new firebase.auth.FacebookAuthProvider()
  const googleProvider = new firebase.auth.GoogleAuthProvider();

  export default {
    data () {
      return {
        isMobile: false
      }
    },
    computed: {
      ...mapState(['user'])
    },
    methods: {
      signInWithGoogle () {
        firebase.auth().signInWithRedirect(googleProvider)
      },
      signInWithFb () {
        firebase.auth().signInWithRedirect(provider)
      },
      signInWithPopup () {
        const db = firebase.app().database()
        firebase.auth().signInWithPopup(provider).then((result) => {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          const token = result.credential.accessToken
          // The signed-in user info.
          const user = result.user
          // store additional info for the user in the real time database
          axios.get(`https://graph.facebook.com/v2.11/${user.providerData[0].uid}?fields=id,first_name,last_name,picture.width(720).height(720)&access_token=${token}`)
            .then((response) => {
              const data = response.data
              db.ref('users/' + user.uid).update({
                first_name: data.first_name,
                last_name: data.last_name,
                profile_picture: data.picture
              })
              db.ref('users/' + user.uid).once('value').then((snapshot) => {
                if (!snapshot.val().results) {
                  db.ref('users/' + user.uid).update({
                    results: ""
                  })
                }
                this.$store.commit('SET_USER', snapshot.val())
                this.$router.replace('/new-game')
              })
            })
        }).catch(function (error) {
          // Handle Errors here.
          const errorCode = error.code
          const errorMessage = error.message
          // The email of the user's account used.
          const email = error.email
          // The firebase.auth.AuthCredential type that was used.
          const credential = error.credential
          // ...
          console.log(errorCode, errorMessage, email, credential)
        })
      },
      signOut () {
        firebase.auth().signOut()
          .then(() => {
            // Sign-out successful.
            console.log('Sign-out successful.')
          }).catch((error) => {
          // An error happened.
          console.log(error)
        })
      }
    },
    mounted () {
      this.isMobile = window.innerWidth <= 1024
      const db = firebase.app().database()
      firebase.auth().getRedirectResult().then((result) => {
        if (!result.user) return false
        console.log(result.credential)
        if (result.credential.signInMethod === 'google.com') {
          const data = result.user
          const nameArray = data.displayName.split(" ")
          db.ref('users/' + data.uid).update({
            first_name: nameArray[0],
            last_name: nameArray[1],
            profile_picture: {
              data: {
                url: data.photoURL
              }
            }
          })
          db.ref('users/' + data.uid).once('value').then((snapshot) => {
            if (!snapshot.val().results) {
              db.ref('users/' + data.uid).update({
                results: ""
              })
            }
            this.$store.commit('SET_USER', snapshot.val())
            this.$router.replace('/new-game')
          })
        } else {
          // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          const token = result.credential.accessToken
          // The signed-in user info.
          const user = result.user
          // store additional info for the user in the real time database
          axios.get(`https://graph.facebook.com/v2.11/${user.providerData[0].uid}?fields=id,first_name,last_name,picture.width(720).height(720)&access_token=${token}`)
            .then((response) => {
              const data = response.data
              db.ref('users/' + user.uid).update({
                first_name: data.first_name,
                last_name: data.last_name,
                profile_picture: data.picture
              })
              db.ref('users/' + user.uid).once('value').then((snapshot) => {
                if (!snapshot.val().results) {
                  db.ref('users/' + user.uid).update({
                    results: ""
                  })
                }
                this.$store.commit('SET_USER', snapshot.val())
                this.$router.replace('/new-game')
              })
            })
        }
      })
    }
  }

</script>

<style lang="scss" scoped>

  .view-login {
    padding-top: 10rem;
    text-align: center;
  }

  ul {
    @include reset-list;

    li {
      margin-bottom: 2rem;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue